import {Tr} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {ClanTaskOption, RaidDifficulty} from "@/store/clan/types";
import {ListService} from "@/services/list-service";
import {AmountPanel} from "@/scenes.ui/amount-panel";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class RaidDifficultyPanel extends VerticalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, options: ClanTaskOption[], callback: (raidDifficulty: RaidDifficulty) => unknown) {
        super(scene, canvas, ' ' + Tr('zadanie'));
        this.setDepth(ListService.DEPTH + 1);

        let blockFirst = TextUtils.addTextAdvanced(scene, Tr('ustanovite.predpochtitelnuju.slozhnost.zadanija'), 0, -190,
            '#ffffff', 14, 'normal', 400, 'center', 2, Fonts.MYRIADPRO_REGULAR);
        this.add(blockFirst);

        let opY = blockFirst.y / CU.S + 45;
        for (let op of options) {
            this.initBlock(op, opY);
            opY += 65;
        }

        let blockSecond = TextUtils.addTextAdvanced(scene, Tr('izmenenija.vstupjat.v.silu.so.sledujuschego.zadanija.') +
            Tr('takzhe.obratite.vnimanie.na.moment'), 0, opY + 10,
            '#dcdbdb', 10, 'normal', 400, 'center', 2, Fonts.MYRIADPRO_REGULAR);
        this.add(blockSecond);
        opY = blockSecond.y / CU.S + 80;

        let rd: RaidDifficulty = RaidDifficultyPanel.getCurrOption(options);

        this.addButt(RaidDifficulty.EASY, rd, -150, opY, callback);
        this.addButt(RaidDifficulty.NORMAL, rd, -50, opY, callback);
        this.addButt(RaidDifficulty.HARD, rd, 50, opY, callback);
        this.addButt(RaidDifficulty.EXTREME, rd, 150, opY, callback);
    }

    private addButt(rd: RaidDifficulty, pickedOption: RaidDifficulty, x: number, y: number, callback: (raidDifficulty: RaidDifficulty) => unknown) {
        SpriteUtils.scale(this.addCustomButton(x, y, RaidDifficultyPanel.toString(rd), Keys.UI_ART_BROWN_BUTTON,
            Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, () => callback(rd)), 0.7 / CU.S, 0.7 / CU.S)
            .setAlpha(rd === pickedOption ? 0.3 : 1);
    }

    private initBlock(op: ClanTaskOption, startY: number) {
        let info = TextUtils.addTextAdvanced(this.scene, RaidDifficultyPanel.toString(op.raidDifficulty)
            + (op.current ? Tr('vibrano') : '') + ' - ' + Tr('req.gain') + ': ' + String(op.count),
             0, startY, '#f3f3f3', 12, 'normal', 400, 'center', 2, Fonts.MYRIADPRO_REGULAR);
        let pricePanel: AmountPanel = new AmountPanel(this.scene, op.raidDifficulty === RaidDifficulty.EXTREME ? -130 : -100, startY + 10,
            Tr('nagrada').toLowerCase() + ': ', op.award);
        this.add([info, pricePanel]);
    }

    private static getCurrOption(ops: ClanTaskOption[]): RaidDifficulty {
        for (let op of ops) {
            if (op.current) {
                return op.raidDifficulty;
            }
        }
        return RaidDifficulty.NORMAL;
    }

    private static toString(rd: RaidDifficulty): string {
        switch (rd) {
            case RaidDifficulty.EASY:
                return Tr('legkoe');
            case RaidDifficulty.NORMAL:
                return Tr('standartnoe');
            case RaidDifficulty.HARD:
                return Tr('slozhnoe');
            case RaidDifficulty.EXTREME:
                return Tr('neverojatnoe');
        }
    }
}
